/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Evgenij Tyan
 * @author Yakov Gushchin
 * @version 1.0.0
 * @since 1.0.0
 */
import ICommonTranslationMultiSelect from '../../types/common/multiSelect';

const initTranslationMultiSelect: ICommonTranslationMultiSelect = {
    close: '',
    foundNothing: '',
    notFound: '',
    OK: '',
    placeholder: '',
    searchPlaceholder: '',
    startSearch: '',
};

export default initTranslationMultiSelect;
